import { type IActivity } from '#app/models/activity._._definitions.ts'
import { type IChatMember } from '#app/models/chat-member._._definitions.ts'
import { type IChat } from '#app/models/chat._._definitions.ts'
import { type IMessage } from '#app/models/message._._definitions.ts'
import { type ObjectValues } from '#app/utils/typescript-helpers.ts'

export type IServerSentEntity = IChat | IMessage | IChatMember | IActivity

export const SSE_STREAM = {
	TEST: 'test',
	NEW_CHAT: 'new-chat',
	NEW_CHAT_MESSAGE: 'new-chat-message',
	NEW_CHAT_MEMBER: 'new-chat-member',
	NEW_ACTIVITY: 'new-activity',
} as const
export type ISseStream = ObjectValues<typeof SSE_STREAM>
